// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetByArticleNumberRequestModel from '../../model/get-by-article-number-request-model';
import GetByArticleNumberRequestDTO from '../dto/get-by-article-number-request-dto';
import dtoSchema from '../schemas/get-by-article-number-request-schema';

export default abstract class GetByArticleNumberRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetByArticleNumberRequestDTO>) {
    super();
    if (data) {
      this.articleNumber = data.articleNumber;
    }
  }
  /**
  */
  articleNumber?: string;

  static toModel(dto: DeepPartial<GetByArticleNumberRequestDTO>): GetByArticleNumberRequestModel;
  static toModel(dto: DeepPartial<GetByArticleNumberRequestDTO> | undefined | null): GetByArticleNumberRequestModel | undefined;
  static toModel(dto: DeepPartial<GetByArticleNumberRequestDTO> | undefined | null): GetByArticleNumberRequestModel | undefined {
    return dto ? new GetByArticleNumberRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetByArticleNumberRequestModel> | GetByArticleNumberRequestModel): GetByArticleNumberRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      articleNumber: unwrapped.articleNumber,
    } as GetByArticleNumberRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetByArticleNumberRequestModel, can not map to GetByArticleNumberRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
